module.exports = __webpack_public_path__ + "static/media/denied.5479deff.svg";